import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "../../../assets";
import { updateBasket } from "../../../actions/basket";
import AddressSelector from "../../AddressSelector";
import { addressToString, vendorPath } from "../../../helpers";
import Checkout from "../../Checkout";
import { useHistory } from "react-router-dom";
import OrderTypeSelector from "./OrderTypeSelector";
import { DELIVERY, COLLECTION } from "../../../constants";
import OrderTimeSelector from "./OrderTimeSelector";
import TextareaField from "../../../assets/TextareaField";

export default function Basket() {

	const history = useHistory();
	const dispatch = useDispatch();

	const {
		vendor,
		basket
	} = useSelector(state => ({
		vendor: state.vendor,
		basket: state.basket
	}));
	const [changes, setChanges] = useState({});

	const values = {
		...basket,
		...changes
	}

	const basketCount = basket.items.reduce((acc, item) => acc + item.quantity, 0);

	useEffect(() => {
		if (!basketCount && !basket.loading)
			history.push(vendorPath(vendor.slug));
	}, [basketCount, basket, vendor, history]);

	useEffect(() => {
		if (!basket.loading)
			setChanges({});
	}, [basket]);

	useEffect(() => {
		if (!Object.keys(changes).length) return;
		const to = setTimeout(() => {
			dispatch(updateBasket(changes));
		}, 1000);
		return () => {
			clearTimeout(to);
		}
	}, [changes, dispatch]);

	if (!basket && basket.loading) return <Spinner
		color={"#000000"}
		size={50}
		fullscreen={true}
	/>

	function canComplete() {
		return Boolean(basket.items.length && (
			(basket.type === COLLECTION && vendor.acceptCollection) ||
			(basket.type === DELIVERY && basket.deliveryAddress)
		));
	}

	return <div className="basket">
		<div className="panel">

			{/* For choosing the delivery type */}
			<section className="delivery-selector">
				<h4>
					Picking up or staying in?
			</h4>
				<div className="inner">
					<OrderTypeSelector />
				</div>
			</section>


			{Boolean(basket && basket.type) && <>
				<section>
					<h4>
						{basket.type === DELIVERY ? "When do you want it?" : "When will you collect?"}
					</h4>
					<div className="inner orderTime">
						<OrderTimeSelector />
					</div>
				</section>

				{/* For setting your address. */}
				{basket.type === DELIVERY && <section>
					<h4>Where shall we deliver?</h4>
					<div className="inner">
						<AddressSelector
							origin={vendor.address && vendor.address.location ? vendor.address.location : null}
							currentAddress={basket.deliveryAddress}
							onChange={deliveryAddress => {
								dispatch(updateBasket({ deliveryAddress }));
							}}
						/>
					</div>
				</section>}

				{basket.type === COLLECTION && <section>
					<h4>
						Pick up from
                	</h4>
					<div className="inner">
						{vendor.address ? addressToString(vendor.address) : ""}
					</div>
				</section>}

				{(basket.type === COLLECTION || (basket.type === DELIVERY && basket.deliveryAddress)) && <section >
					<h4>Order notes</h4>
					<div className="inner">
						<TextareaField
							value={values.notes || ""}
							onChange={notes => setChanges({ ...changes, notes })}
						/>
					</div>
				</section>}

				{canComplete() && <>
					<section>
						<br /><br />
						<div className="inner">
							<Checkout blocked={Boolean(Object.keys(changes).length)} />
						</div>
					</section>
				</>
				}
			</>
			}

			{/* <div className="spacer" style={{
				paddingBottom: 90
			}} /> */}
		</div>
	</div >
}
